import { IDeliveryAddress } from 'client/IClientInfo'
import GeneratedFrom from 'components/generated_form/GeneratedFrom'
import IInput, { TInputType } from 'components/generated_form/IInput'
import BlueButton from 'components/inputs/BlueButton'
import RedButton from 'components/inputs/RedButton'
import React, { useCallback, useEffect, useState } from 'react'
import SelectCity from 'select_with_global_state/SelectCity'

const DEFAULT_CITY_ID = 2 // павловск

interface IDeliveryAddressFormProps {
  address: IDeliveryAddress | null
  onAccept: (address: IDeliveryAddress) => void
  onCancel: VoidFunction
}

const DeliveryAddressForm: React.FC<IDeliveryAddressFormProps> = ({
  address,
  onAccept,
  onCancel,
}) => {
  const [inputs, setInputs] = useState<IInput[]>([])
  const [error, setError] = useState('')
  const [formValues] = useState<any>({})

  useEffect(() => {
    setInputs([
      {
        id: 'city_id',
        type: 'component' as TInputType,
        title: 'Город',
        otherProps: { maxLength: 50 },
        component: (onChange: (value: string | number | null) => void) => (
          <SelectCity
            onSelect={(val) => {
              console.log('select', val)
              onChange(val)
            }}
            defaultItemId={address?.city_id || DEFAULT_CITY_ID}
          />
        ),
      },
      {
        id: 'street',
        type: 'str' as TInputType,
        title: 'Улица',
        otherProps: { maxLength: 50 },
        defaultValue: address?.street,
        required: true,
      },
      {
        id: 'building',
        type: 'str' as TInputType,
        title: 'Дом',
        otherProps: { maxLength: 10 },
        defaultValue: address?.building,
        required: true,
      },

      {
        id: 'flat',
        type: 'int' as TInputType,
        title: 'Квартира',
        defaultValue: address?.flat,
      },
      {
        id: 'entrance',
        type: 'int' as TInputType,
        title: 'Подъезд',
        defaultValue: address?.entrance,
      },
      {
        id: 'floor',
        type: 'int' as TInputType,
        title: 'Этаж',
        defaultValue: address?.floor,
      },
    ])
  }, [address])

  const handleChange = (key: string, value: string | number | null) => {
    formValues[key] = value
    console.log(key, value)
  }

  const handleAccept = useCallback(() => {
    console.log(formValues)

    let newAddress: IDeliveryAddress | null = null

    if (address) {
      address.city_id = formValues.city_id || address.city_id
      address.street = formValues.street || address.street
      address.building =
        formValues.building !== undefined ? formValues.building : address.building
      address.flat = formValues.flat !== undefined ? formValues.flat : address.flat
      address.entrance =
        formValues.entrance !== undefined ? formValues.entrance : address.entrance
      address.floor = formValues.floor !== undefined ? formValues.floor : address.floor
      newAddress = address
    } else {
      newAddress = {
        deliv_addr_id: -1,
        city_id: formValues.city_id || DEFAULT_CITY_ID,
        street: formValues.street,
        building: formValues.building,
        flat: formValues.flat,
        entrance: formValues.entrance,
        floor: formValues.floor,
      }
    }
    if (newAddress) {
      if (!newAddress.street || !newAddress.building) {
        setError('Заполните все поля')
      } else {
        onAccept(newAddress)
        setError('')
      }
    }
  }, [formValues, address, onAccept])

  return (
    <>
      <GeneratedFrom inputs={inputs} inTwoColumn onChange={handleChange} />
      {error && (
        <div
          className='h3-rem mb-2 d-flex justify-content-center'
          style={{ color: 'var(--color-red)' }}
        >
          {error}
        </div>
      )}
      <div className='d-flex gap-3'>
        <BlueButton onClick={handleAccept} style={{ width: '100%' }}>
          Принять
        </BlueButton>
        <RedButton onClick={onCancel} style={{ width: '100%' }}>
          Отмена
        </RedButton>
      </div>
    </>
  )
}
export default DeliveryAddressForm
